module.exports = __webpack_public_path__ + "img/Frame 10864@2x.937b07f6.png";